const GoIcon = (props) => {
    return (
        <svg
          width={20}
          height={20}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M8.822 32.845a1.666 1.666 0 010-2.357L19.31 20 8.822 9.512a1.666 1.666 0 112.356-2.357l11.667 11.667c.65.65.65 1.706 0 2.356L11.178 32.845a1.662 1.662 0 01-2.356 0zm19.511.488c.92 0 1.667-.746 1.667-1.666V8.333a1.667 1.667 0 00-3.333 0v23.334c0 .92.746 1.666 1.666 1.666z"
            fill="#fff"
          />
        </svg>
      )
}

export default GoIcon